(()=>{
  'use strict';
  const guideIds=['first-game','family-time','birthday-battle'];
  function init(root){
    if(!root||root.dataset.journalReady)return;
    root.dataset.journalReady='true';
    const listing=root.querySelector('[data-journal-listing]');
    const reader=root.querySelector('[data-journal-reader]');
    const guides=[...root.querySelectorAll('[data-journal-guide]')];
    const status=root.querySelector('[data-journal-status]');
    const pageTitle=document.title;
    const getGuide=()=>{
      const candidate=new URL(location.href).searchParams.get('guide');
      return guideIds.includes(candidate)?candidate:null;
    };
    const show=(id,focus=false)=>{
      const active=guides.find(article=>article.dataset.journalGuide===id);
      root.dataset.journalView=active?'guide':'index';
      listing.hidden=Boolean(active);
      reader.hidden=!active;
      guides.forEach(article=>{
        article.hidden=article!==active;
        const heading=article.querySelector('h2');
        if(article===active){heading.setAttribute('role','heading');heading.setAttribute('aria-level','1');}
        else{heading.removeAttribute('role');heading.removeAttribute('aria-level');}
      });
      if(active){
        const heading=active.querySelector('h2');
        const title=heading.textContent.trim().replace(/([.!?])(?=\S)/g,'$1 ').replace(/\s+/g,' ');
        document.title=title+' · BEAM RIVALS Play Journal';
        if(status)status.textContent=title;
        if(focus){
          heading.focus({preventScroll:true});
          root.scrollIntoView({block:'start',behavior:'instant'});
        }
      }else{
        document.title=pageTitle;
        if(status)status.textContent='All game night guides';
        if(focus){
          const heading=root.querySelector('h1');
          heading.tabIndex=-1;
          heading.focus({preventScroll:true});
          root.scrollIntoView({block:'start',behavior:'instant'});
        }
      }
    };
    root.addEventListener('click',event=>{
      if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      const anchor=event.target.closest('a[data-guide-link],a[data-journal-back]');
      if(!anchor||!root.contains(anchor))return;
      const url=new URL(anchor.href,location.href);
      if(url.origin!==location.origin)return;
      const id=anchor.dataset.guideLink||null;
      if(id&&!guideIds.includes(id))return;
      event.preventDefault();
      history.pushState({},'',url.pathname+url.search+url.hash);
      show(id,true);
    });
    addEventListener('popstate',()=>{
      if(root.isConnected)show(getGuide(),true);
    });
    show(getGuide());
  }
  document.querySelectorAll('[data-play-journal]').forEach(init);
  document.addEventListener('shopify:section:load',event=>{
    event.target.querySelectorAll('[data-play-journal]').forEach(init);
  });
})();
